// extracted by mini-css-extract-plugin
module.exports = {"header":"integrations_header__NvyFJ","title":"integrations_title__88re2","subtitle":"integrations_subtitle__EwtBw"};